<div class="modal" [class.fade]="true" [class.in]="mVisible" [style.display]="mVisible ? 'block' : 'none'"
	role="dialog">

	<div class="modal-dialog modal-sm">
		<div class="modal-content">
			<div class="modal-body text-center">

				<!-- Execution Message -->
				<p style="font-size: 24px; font-weight: bold; color: #ffffff">
					Executing function...
				</p>

				<!-- Function Name White Box -->
				<div id="functionExecutingModalFunctionName" class="white-box">
					{{ mFunctionName }}
				</div>

				<!-- Status Message -->
				<div id="functionExecutingModalStatus">
					{{ mExecutionMessage }}
				</div>

				<!-- RESULT SECTION -->
				<div *ngIf="!mIsExecuting  && returnType !== null">

					<!-- Result Label White Box -->
					<div class="white-box result-label" id="functionExecutingModalFunctionName">
						Result
					</div>

					<!-- Scrollable Result Container -->
					<div style="
     max-height: 250px;
     overflow-y: auto;
     padding: 8px;
     ">

						<!-- STRING / INTEGER -->
						<div *ngIf="returnType !== null && returnType !== 'BOOLEAN'"
							style="display: flex; align-items: center; justify-content: space-between; width: 100%;">

							<span style="flex: 1; display: block; white-space: pre-wrap;">
								{{ returnData }}
							</span>

							<i class="fa fa-copy" aria-hidden="true" title="Copy" style="cursor: pointer;"
								(click)="copyResult()"></i>


							<!-- BOOLEAN -->
							<div *ngIf="returnType !== null && returnType === 'BOOLEAN'" style="display: flex; align-items: center; gap: 8px;">

								<span style="flex: 1; display: block; white-space: pre-wrap;"><input type="checkbox" [checked]="isChecked" disabled /></span>

								<i class="fa fa-copy" aria-hidden="true" title="Copy" style="cursor: pointer;"
									(click)="copyResult()"></i>
							</div>

						</div>
					</div>



				</div>
				<!-- OK Button (Moved Below Result) -->
				<button type="button" class="btn btn-default btn-lg" [disabled]="mIsExecuting" (click)="hide()">
					OK
				</button>
			</div>
		</div>
	</div>